import React from 'react'
import { InfoHint } from './info-hint'

interface SelectWrapperProps {
  label: string
  /** Optional explanation revealed by a (?) beside the label. */
  hint?: string
  children: React.ReactNode
  onBlur?: () => void
  'data-testid'?: string
}

export const SelectWrapper: React.FC<SelectWrapperProps> = ({
  label,
  hint,
  children,
  onBlur,
  'data-testid': dataTestId,
}) => {
  return (
    <div onBlur={onBlur} data-testid={dataTestId} className="w-full text-left">
      <span className="mb-1 block text-sm font-medium text-primary">
        {label}
        {hint && <InfoHint text={hint} className="ml-1.5" />}
      </span>
      {children}
    </div>
  )
}
